import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import {
    Landing,
    About,
    Team,
    Services,
    Impact,
    Contact,
    Partners,
    Projects,
    ProjectDetail,
    TektronGroup,
    Thermo
} from './pages';
import { ScrollToTop } from './components';
import { Analytics } from "@vercel/analytics/react"
function ScrollToTopOnNav() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
        <Analytics />
      <ScrollToTopOnNav />
      <Routes>
        <Route path="/"                element={<Landing       />} />
        <Route path="/about"           element={<About         />} />
        <Route path="/team"            element={<Team          />} />
        <Route path="/services"        element={<Services      />} />
        <Route path="/impact"          element={<Impact        />} />
        <Route path="/contact"         element={<Contact       />} />
        <Route path="/partners"        element={<Partners      />} />
        <Route path="/projects"        element={<Projects      />} />
        <Route path="/projects/:id"    element={<ProjectDetail />} />
        <Route path="/group"           element={<TektronGroup  />} />
        <Route path="/thermo"        element={<Thermo        />} />
      </Routes>
      <ScrollToTop />
    </BrowserRouter>
  );
}

export default App;
